var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VDialog',{attrs:{"content-class":"preview"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('img',{staticClass:"preview__img",attrs:{"src":_vm.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }